import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
import { Observable,ReplaySubject,Subject,throwError } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { UserDataService } from '../userData/user-data.service';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private loggedIn: Subject<boolean> = new ReplaySubject<boolean>(1);

  constructor(  
    public http : HttpClient,
    public userService : UserDataService,
    public router: Router,
    public toastController : ToastController
  ) { }
  private extractData(res: Response) {
    let body = res;
    return body || { };
  }
doSignup(payload:any):Observable<any>{
  console.log(payload)
  let url = CommonService.BASE_URL + '/api/v1/public/user/signup/' + payload.otp
  
  let headers: HttpHeaders = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.http.post(url,payload, {
      headers: headers
    })
  .pipe(
    map(this.extractData),
    catchError(error => {
      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${error.error}`);
          if(error.status === 403) {
            window.dispatchEvent(new CustomEvent('user:force-logout'));
          }
      }
      // return an observable with a user-facing error message
      return throwError(
        'Something bad happened; please try again later.');
    })
  );
}
  doLogin(username: string, password: string) {
    let url = CommonService.BASE_URL + '/api/v1/public/user/login'
    let payload = {
      "password": password,
      "username": username
    };
    let headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    return this.http.post(url, payload, {
      headers: headers
    })
    .pipe(
      tap(() => this.loggedIn.next(true))
    )
    .pipe(
      catchError(this.handleError)
    );
  }

  logout() {
    this.loggedIn.next(false)
  }
  
  loginStatusChange(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
        if(error.status == 401){
          return throwError(error.status);
        }
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

  saveProfile(payload:any,token:any):Observable<any>{
    let url = CommonService.BASE_URL + '/api/v1/secure/profile/save';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    }
   
    return this.http.post(url,payload,httpOptions)
    .pipe(
      map(this.extractData),
      catchError(error => {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
            if(error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
        }
        // return an observable with a user-facing error message
        return throwError(
          'Something bad happened; please try again later.');
      })
    );
  }

  checkEmail(emailId: any) {
    let url = CommonService.BASE_URL + "/api/v1/public/security/checkAndSend/" + emailId
    let headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(url, {
      headers: headers
    })
      .pipe(
        map(this.extractData),
        catchError(this.handleErrorAndReturnCode)
      );
  }

  private handleErrorAndReturnCode(error: HttpErrorResponse) {
    if (error.status === 403) {
      window.dispatchEvent(new CustomEvent('user:forbidden'));
    } else if (error.status === 400) {
      window.dispatchEvent(new CustomEvent('user:badRequest'));
    }

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      {
        message: 'Something bad happened; please try again later.',
        errorCode: error.status
      });
  };

  resetPwd(otp: any, payload: any) {
    let url = CommonService.BASE_URL + "/api/v1/public/security/resetpassword/" + otp
    let headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(url, payload, {
      headers: headers
    })
      .pipe(
        map(this.extractData),
        catchError(this.handleErrorAndReturnCode)
      );
  }


}
